export enum Basemap {
  OpenStreetMaps = 'OpenStreetMaps',
}

export interface BasemapOption {
  id: Basemap
  name: string
}

export interface ViewState {
  center: [number, number]
  zoom: number
  provider: string
}
